module.exports = __webpack_public_path__ + "static/media/reset.4344e747.svg";